import { Component, OnInit } from '@angular/core';
import { LanguageService, Language } from '../../services/language.service';

@Component({
  selector: 'app-language-selector',
  template: `
    <div class="language-selector" [class.hidden-mobile]="isMobileView">
      <select 
        [value]="currentLanguage" 
        (change)="onLanguageChange($event)"
        class="language-select"
        title="Select Language">
        <option 
          *ngFor="let lang of availableLanguages" 
          [value]="lang.code"
          [selected]="lang.code === currentLanguage">
            {{getLanguageDisplay(lang)}}
        </option>
      </select>
    </div>
  `,
  styles: [`
    .language-selector {
      display: inline-block;
      position: relative;
    }
    
    .language-selector.hidden-mobile {
      display: none !important;
    }
    
    .language-select {
      padding: 6px 10px;
      border: 1px solid #e4e9f0;
      border-radius: 4px;
      background-color: #ffffff;
      font-size: 13px;
      cursor: pointer;
      outline: none;
      transition: all 0.3s ease;
      min-width: 120px;
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e");
      background-position: right 8px center;
      background-repeat: no-repeat;
      background-size: 16px;
      padding-right: 32px;
    }
    
    .language-select:hover {
      border-color: #598bff;
      background-color: #f8f9fc;
    }
    
    .language-select:focus {
      border-color: #598bff;
      box-shadow: 0 0 0 2px rgba(89, 139, 255, 0.2);
      background-color: #ffffff;
    }
    
    .language-select option {
      padding: 8px 12px;
      background-color: #ffffff;
      color: #2a2a2a;
    }
    
    .language-select option:hover {
      background-color: #f8f9fc;
    }

    @media screen and (max-width: 576px) {
      .language-selector {
        display: none !important;
      }
    }
  `]
})
export class LanguageSelectorComponent implements OnInit {
  availableLanguages: Language[] = [];
  currentLanguage: string = 'en';
  isMobileView: boolean = false;

  constructor(private languageService: LanguageService) {
    // Initialize mobile view check
    this.checkMobileView();
    // Listen for window resize events
    window.addEventListener('resize', () => this.checkMobileView());
  }

  ngOnInit(): void {
    this.availableLanguages = this.languageService.getAvailableLanguages();
    this.languageService.getCurrentLang().subscribe(lang => {
      this.currentLanguage = lang;
    });
  }

  onLanguageChange(event: any): void {
    const selectedLang = event.target.value;
    this.languageService.setLanguage(selectedLang);
  }

  private checkMobileView(): void {
    this.isMobileView = window.innerWidth <= 576;
  }

  getLanguageDisplay(lang: Language): string {
    // Since language selector is hidden on mobile, always show full display
    return `${lang.prefix} - ${lang.nativeName}`;
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', () => this.checkMobileView());
  }
} 